import React from 'react';
import useDocument from './useDocument';
import Document from './Components/Document';

const DocumentIndex: React.FC = () => {
  const documentProps = useDocument();

  return (
  <Document/>
);
};
export default DocumentIndex;
